import { useState, useCallback } from 'react'

import { DAYS_PER_PAGE } from '../constants/chartConstants'

function useChartPagination(totalItems) {
  const [currentPage, setCurrentPage] = useState(0)
  const totalPages = Math.ceil(totalItems / DAYS_PER_PAGE)

  const goToPrevious = useCallback(() => {
    setCurrentPage(p => Math.min(p + 1, totalPages - 1))
  }, [totalPages])

  const goToNext = useCallback(() => {
    setCurrentPage(p => Math.max(p - 1, 0))
  }, [])

  const periodLabel = currentPage === 0
    ? `Last ${DAYS_PER_PAGE} days`
    : `Days ${currentPage * DAYS_PER_PAGE + 1}-${(currentPage + 1) * DAYS_PER_PAGE}`

  return {
    currentPage,
    totalPages,
    periodLabel,
    goToPrevious,
    goToNext,
    canGoPrevious: currentPage < totalPages - 1,
    canGoNext: currentPage > 0,
  }
}

export default useChartPagination
